import styled from '@emotion/styled';

import { RESPONSIVE_CLASSES } from '../../styles/emotion/mixins/responsive';
import { COLORS3 as COLORS, FONT, MEDIA_QUERY, SPACING } from '../../styles/emotion';

import { AccordionV2 } from '../AccordionV2';
import { AccordionSection, AccordionSectionHeading } from '../AccordionV2/AccordionV2.styles';
import { FeaturedImageWrapper, StyledBackgroundImage, StyledPicture } from './FeaturedImage.styles';
import { LinkV2 } from '../LinkV2';

export const DifferentiationWrapper = styled.div`
  max-width: 1920px;
`;

export const SectionWrapper = styled.div`
  display: grid;
  flex-direction: row;
  grid-template-columns: repeat(3, 1fr);
  height: calc(100vh - 130px);
  min-height: 810px;
  padding: 0px;
`;

export const AccordionWrapper = styled.div`
  align-items: flex-start;
  border-bottom: var(--border-divider, 1px solid ${COLORS.BLACK_030});
  display: flex;
  flex-flow: column;
  height: auto;
  min-height: auto;
  padding: ${SPACING.S32} ${SPACING.S24};

  ${MEDIA_QUERY.TABLET} {
    padding: 56px;
  }
`;

export const Sidebar = styled.div<{ isPhotoOnRight: boolean }>`
  background-color: var(--background-screen, ${COLORS.WHITE_100});
  border: var(--border-grid, 1px solid ${COLORS.BLACK_030});
  display: flex;
  flex-flow: column;
  grid-row: 1;
  height: inherit;
  min-height: 810px;
  padding: ${SPACING.LG};

  ${({ isPhotoOnRight }) => `
    grid-column-start: ${isPhotoOnRight ? 1 : 3};
    border-width: ${isPhotoOnRight ? '0 1px 1px 0' : '0 0 1px 1px'};
  `}
`;

export const TitleWrapper = styled.div`
  color: var(--text-primary, ${COLORS.BLACK_100});
  margin-top: 0;
  padding-bottom: 28px;

  ${MEDIA_QUERY.TABLET} {
    padding-bottom: 43px;
  }

  ${MEDIA_QUERY.DESKTOP} {
    margin-top: ${SPACING.S24};
    padding-bottom: 0;
  }
`;

export const UnselectedItemWrapper = styled(LinkV2)`
  text-align: left;

  &:before {
    bottom: 0;
    content: ' ';
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
`;

export const HiddenContent = styled.div`
  display: none;
`;

export const MenuItem = styled.div<{ isSelected: boolean }>`
  border-bottom: var(--border-divider, 1px solid ${COLORS.BLACK_030});
  padding: 34px 0;
  position: relative;
  width: 100%;

  ${UnselectedItemWrapper} {
    color: var(--text-tertiary, ${COLORS.BLACK_050});
  }

  &:hover,
  &:focus-visible {
    ${UnselectedItemWrapper} {
      color: var(--text-primary, ${COLORS.BLACK_100});
    }
  }

  ${({ isSelected }) =>
    isSelected &&
    `
    border-bottom: var(--border-divider, 1px solid ${COLORS.BLACK_030});
  `}
`;

export const MenuWrapper = styled.div`
  margin-top: auto;

  *:last-child {
    border-bottom: none;
  }
`;

export const MenuItemTitle = styled.p`
  align-items: center;
  align-self: start;
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  margin: 0;

  svg {
    vertical-align: middle;
    padding-right: 0.2em;
    padding-bottom: 0.1em;
    &:after {
      left: 0.2em;
      position: relative;
      margin-right: -0.8em;
    }
  }
`;

export const MenuItemDescription = styled.p`
  margin: 0;
  padding-top: ${SPACING.S16};
  line-height: 150%;
`;

export const ButtonWrapper = styled.div`
  padding-top: ${SPACING.S16};
`;

export const ImageWrapper = styled.div<{ isPhotoOnRight: boolean }>`
  border-bottom: var(--border-grid, 1px solid ${COLORS.BLACK_030});
  flex: 1;
  grid-column-end: span 2;
  grid-row: 1;
  height: inherit;
  min-height: 810px;
  padding: ${SPACING.SM};

  ${FeaturedImageWrapper},
  ${StyledBackgroundImage},
  ${StyledPicture} {
    height: 100%;
  }

  ${({ isPhotoOnRight }) => `
    grid-column-start: ${isPhotoOnRight ? 2 : 1};
  `}
`;

export const StyledAccordion = styled(AccordionV2)`
  width: 100%;

  ${AccordionSection}:last-of-type {
    border-bottom: none !important;
  }

  ${AccordionSectionHeading} {
    text-align: left !important;
  }
`;

export const DekWrapper = styled.div`
  display: flex;
  flex-flow: column;
  row-gap: 28px;
`;

export const AccordionImageWrapper = styled.div`
  ${MEDIA_QUERY.MOBILE} {
    height: 300px;

    ${FeaturedImageWrapper} {
      height: 100%;
    }
  }
`;

export const HiddenOnDesktop = styled.div`
  ${RESPONSIVE_CLASSES.excludeDesktop}
`;

export const OnlyOnDesktop = styled.div`
  ${RESPONSIVE_CLASSES.desktopOnly}
`;
